<template>
  <div>
    <div class="col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">Review</h4>
        <div class="category">Check the details of your verification{{verifications.length > 1 ? 's' : ''}} are correct</div>
      </div>
      <div class="card-content">
        <div class="row">

<!--
        <result v-for="verification, index in verifications" :key="index" result="NEW" :verification="verification | addIndex(index)"> 
          <span class="btn btn-danger btn-fill" slot="vBadge">{{formatMoney(verification.institute.total)}}</span>
          <div class="card-footer" slot="footer" style="display: none" />
          <div slot="actions" style="padding-bottom: 20px">
            <button @click.prevent="$emit('editVerification', verification)" type="button" class="btn btn-wd btn-default btn-fill"><i class="fa fa-pencil"></i> Edit</button>
            <button v-if="verifications.length > 1" @click.prevent="$emit('deleteVerification', verification)" type="button" class="btn btn-wd btn-default btn-fill"><i class="fa fa-trash"></i> Delete</button></div>
        </result>
-->
          <result v-if="verification" result="NEW" :verification="verification"> 
            <span class="btn btn-danger btn-fill" slot="vBadge" style="display: none" >{{formatMoney(verification.institute.total)}}</span>
            <div class="card-footer" slot="footer" style="display: none" />
            <div slot="actions" style="padding-bottom: 20px">
              <button @click.prevent="$emit('editVerification', verification)" type="button" class="btn btn-wd btn-default btn-fill"><i class="fa fa-pencil"></i> Edit</button>
              <!--<button v-if="verifications.length > 1" @click.prevent="$emit('deleteVerification', verification)" type="button" class="btn btn-wd btn-default btn-fill"><i class="fa fa-trash"></i> Delete</button>-->
            </div>
          </result>

        </div>
        <div class="row form-horizontal">
          <div class="form-group">
            <label class="col-md-1 control-label">Consent</label>
            <div class="col-md-10">
              <p class="form-control-static"><p-switch v-model="verification.consentTicked" type="info" on-text="Yes" off-text="No"></p-switch></p>
              <span class="help-block">I hold the written consent of the individuals named above and have provided copies of these consents where requested.</span>
            </div>
          </div>
        </div>
        <!--
        <div class="form-group">
          <label class="col-sm-2 control-label">Terms & Conditions</label>
          <div class="col-sm-10">
            <p class="form-control-static text-danger"><p-switch v-model="termsTicked" type="primary" on-text="Yes" off-text="No"></p-switch></p>
            <span class="help-block">I have read and agree to the <a href="https://www.qualificationcheck.com/terms.html" target="_blank">terms & conditions</a> of use of this service.</span>
          </div>
        </div>
        -->
      </div>
    </div>
    <slot name="actions" :allTicked="allTicked" />
  </div>
</template>

<script>
  import Result from 'src/views/Verifications/components/Result'
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import PSwitch from 'src/components/Switch.vue'

  import accounting from 'accounting'
  
  export default {
    name: "order-summary",
    components: {
      Result,
      DynamicInput,
      PSwitch
    },
    props: {
      verification: {type: Object, default: null},
      verifications: {type: Array, default: []}
    },
    data() {
      return {
        termsTicked: false
      }
    },
    computed: {
      allTicked() {
        return this.verification.consentTicked //&& this.termsTicked
      }
    },
    methods: {
      formatMoney(amount) {
        return amount ? accounting.formatMoney(amount) : accounting.formatMoney(0) 
      }
    },
    filters: {
      addIndex(verification, index) {
        verification.index = index
        return verification
      }
    }
  }

</script>